<template>
    <button class="btn btn-xs border" @click="$emit('click')">
        <b-icon-x variant="danger"></b-icon-x>
    </button>
</template>
<script>
export default {
}
</script>